const LITB_LOCAL_DOMAIN: Array<string | RegExp> = [/(?:192.168)/, /(?:localhost)/, /(?:127.0)/];
const LITB_UAT_DOMAIN: Array<string | RegExp> = [/(?:tbox.me)/, ...LITB_LOCAL_DOMAIN];
export const isUAT = (hostname = __SERVER__ ? "" : window.location.hostname): boolean => {
	return LITB_UAT_DOMAIN.some((domain) => {
		return hostname.match(domain);
	});
};
export const isLocalDevelop = (hostname = __SERVER__ ? "" : window.location.hostname): boolean => {
	return LITB_LOCAL_DOMAIN.some((domain) => {
		return hostname.match(domain);
	});
};
